
$(document).on('click', '.show-more-link', function (this: HTMLElement, e: JQuery.ClickEvent) {
  e.preventDefault();
  const $link = $(this);
  if ($link.hasClass('disabled')) return;

  const url = $link.attr('href');
  const targetSelector = $link.data('target') as string | undefined;
  if (!url || !targetSelector) return;

  const $target = $(targetSelector);
  if (!$target.length) {
    window.location.href = url;
    return;
  }

  const originalText = $link.text();
  $link.text('Loading...').addClass('disabled');

  $.get(url)
    .done(function (html: string) {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const newNode = temp.querySelector(targetSelector);
      if (newNode) {
        $target.replaceWith(newNode);
      } else {
        window.location.href = url;
      }
    })
    .fail(function () {
      $link.text(originalText).removeClass('disabled');
      window.location.href = url;
    });
});
